import { DEMO_QUESTION_LIMIT } from './demo.constants';

export type DemoSessionSource = 'api' | 'fallback';

export interface DemoQuestionView {
  id: number;
  questionText: string;
  image: string;
  options: string[];
  sourceName: string;
  sourceLink: string;
  nextQuestion: number | null;
  previousQuestion: number | null;
}

export interface DemoAnswerState {
  userCheck: boolean[];
  checked: boolean;
  isCorrect: boolean | null;
  optionHint: string[];
  optionIsCorrect: boolean[];
}

export interface DemoSession {
  sessionId: string;
  source: DemoSessionSource;
  language: string;
  total: number;
  currentIndex: number;
  completed: boolean;
  questionIds: number[];
  questions: DemoQuestionView[];
  answers: { [questionId: number]: DemoAnswerState };
  correctKeys?: { [questionId: number]: boolean[] };
  hintKeys?: { [questionId: number]: string[] };
}

export interface DemoCheckResult {
  isCorrect: boolean;
  optionHint: string[];
  optionIsCorrect: boolean[];
}

export interface DemoApiQuestion {
  id?: number | string;
  question_text?: string;
  image?: string;
  option_1_text?: string;
  option_2_text?: string;
  option_3_text?: string;
  option_4_text?: string;
  option_5_text?: string;
  question_source_name?: string;
  question_source_link?: string;
  option?: Array<string | { option_text?: string } | null>;
  next_prev_question?: {
    next_question?: number | string | null;
    prev_question?: number | string | null;
  };
}

export interface DemoApiAnswerResponse {
  is_correct?: boolean;
  option_1?: DemoApiOptionResult;
  option_2?: DemoApiOptionResult;
  option_3?: DemoApiOptionResult;
  option_4?: DemoApiOptionResult;
  option_5?: DemoApiOptionResult;
}

export interface DemoApiOptionResult {
  option_hint?: string;
  user_check?: boolean;
  option_is_correct?: boolean;
}

export function emptyAnswerState(): DemoAnswerState {
  return {
    userCheck: [false, false, false, false, false],
    checked: false,
    isCorrect: null,
    optionHint: ['', '', '', '', ''],
    optionIsCorrect: [false, false, false, false, false]
  };
}

export function defaultDemoTotal(count: number): number {
  if (!count || count < 1) {
    return DEMO_QUESTION_LIMIT;
  }
  return Math.min(count, DEMO_QUESTION_LIMIT);
}

export function toQuestionId(value: unknown): number | null {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(value);
  if (!isFinite(parsed) || parsed <= 0) {
    return null;
  }
  return parsed;
}
